import React, { useEffect, useState } from "react";
import { useAtom } from "jotai";
import axios from "axios";
import { axiosClient } from "services/axios";

import { BaseLayout } from "components/BaseLayout/BaseLayout";
import { SemiBoldText } from "components/SemiBoldText/SemiBoldText";
import { Button, EButtonVariant } from "components/Button/Button";
import { NamedInput } from "components/NamedInput/NamedInput";
import { RegularText } from "components/RegularText/RegularText";
import { VerticalSpace } from "components/VerticalSpace/VerticalSpace";

import { loginRequest } from "pages/LoginPage/requests";

import { tokenAtom } from "../../atoms/accountAtom";

import styles from "./styles.module.scss";

const Login = () => {
  const [, setToken] = useAtom(tokenAtom);
  const [login, setLogin] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");

  const onLoginClick = async (ev?: any) => {
    if (ev?.preventDefault) ev.preventDefault();

    const res = await loginRequest({ login, password });

    if (res?.status === 200) {
      const newToken = res.data.token;
      localStorage.setItem("token", newToken);
      setToken(newToken);
    } else {
      setError(res?.data?.message || "Неправильный логин и/или пароль");
    }
  };

  useEffect(() => {
    setError("");
  }, [login, password]);

  return (
    <div className={styles.wrapper}>
      <BaseLayout
        header={<SemiBoldText>Авторизация</SemiBoldText>}
        footer={
          <Button
            onClick={() => onLoginClick()}
            variant={EButtonVariant.SECONDARY}
          >
            Вход
          </Button>
        }
        className={styles.container}
      >
        <form onSubmit={onLoginClick}>
          <VerticalSpace size={15} />
          <RegularText size={16}>Логин:</RegularText>
          <NamedInput
            value={login}
            onChange={(ev) => setLogin(ev.target.value)}
            className={styles.input}
          />
          <VerticalSpace size={15} />
          <RegularText size={16}>Пароль:</RegularText>
          <NamedInput
            value={password}
            onChange={(ev) => setPassword(ev.target.value)}
            type={"password"}
            className={styles.input}
          />
          <VerticalSpace size={15} />
          {error && (
            <>
              <RegularText className={styles.errorText} size={16}>
                {error}
              </RegularText>
              <VerticalSpace size={15} />
            </>
          )}
          <button hidden />
        </form>
      </BaseLayout>
    </div>
  );
};

export default Login;
